import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PopoverContainer = styled.div`
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 16px rgba(87, 87, 87, 0.2);
    position: absolute;
    z-index: 100;
    right: ${props => (props.theme.bodyRight || props.theme.bodyRight === 0 ? `${props.theme.bodyRight}px` : 'auto')};
    top: ${props => (props.theme.bodyTop || props.theme.bodyTop === 0 ? `${props.theme.bodyTop}px` : 'auto')};

    &:after {
        bottom: 100%;
        border: solid transparent;
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #ffffff;
        border-width: 0 10px 12px 10px;
        content: '';
        height: 0;
        position: absolute;
        pointer-events: none;
        width: 0;
        margin-left: -10px;

        left: ${props => {
            if (
                !props.theme.arrowLeft &&
                props.theme.arrowLeft !== 0 &&
                !props.theme.arrowRight &&
                props.theme.arrowRight !== 0
            ) {
                return '50%';
            }

            return props.theme.arrowLeft || props.theme.arrowLeft === 0 ? `${props.theme.arrowLeft}px` : 'auto';
        }};

        right: ${props =>
            props.theme.arrowRight || props.theme.arrowRight === 0 ? `${props.theme.arrowRight}px` : 'auto'};
    }
`;

const SavedSearchSelectionPopover = ({ isOpen, arrowRight, bodyRight, bodyTop, children }) => {
    useEffect(() => {
        //
    }, []);

    if (!isOpen) {
        return null;
    }

    return (
        <PopoverContainer
            theme={{
                arrowRight: arrowRight || arrowRight === 0 ? arrowRight : null,
                bodyRight: bodyRight || bodyRight === 0 ? bodyRight : null,
                bodyTop: bodyTop || bodyTop === 0 ? bodyTop : null,
            }}
        >
            {children}
        </PopoverContainer>
    );
};

SavedSearchSelectionPopover.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    arrowRight: PropTypes.number,
    bodyRight: PropTypes.number,
    bodyTop: PropTypes.number,
    children: PropTypes.node.isRequired,
};

export default SavedSearchSelectionPopover;
